import { Fp } from './fpsdk/NcryFpSdk'
import { ClippingImage } from "../os";
export default class GetFingerImage {
    constructor() {
        this.lastStateCode = -1
        this.initokCallback = null //设备初始化成功开始录入指纹
        this.successCallback = null; //读取到指纹
        this.timeoutCallback = null; //读取超时
        this.offlineCallback = null; //设备不在线
        this.handle = null
    }
    setSuccessCallback(callback) {
        console.log('setSuccessCallback')
        this.successCallback = callback
    }
    setTimeoutCallback(callback) {
        this.timeoutCallback = callback
    }
    setOfflineCallback(callback) {
        this.offlineCallback = callback
    }
    handleProcessedImage = (base64) => {
        if (this.successCallback) {
            this.successCallback(base64)
        }
    }
    //设置指纹初始化成功回调
    setInitokCallback(callback) {
        this.initokCallback = callback
    }
    getImage() {
        Fp.log("please press finger");
        Fp.getImage(this.handle, (returnObj) => {
            var stateCode = returnObj.stateCode
            if (stateCode == Fp.RT_SUCCESS) {
                const imageLen = returnObj.imageLen
                console.log(imageLen)
                if (imageLen > 90000) {
                    let src = 'data:image/png;base64,' + returnObj.image
                    if (this.successCallback) {
                        ClippingImage(src, 192, 255, 1, (res) => {
                            // 创建一个Image对象，加载base64图片
                            var image = document.createElement('img');
                            image.src = res; // 替换为您的base64图片数据
                            // 当图片加载完成后执行处理
                            image.onload = () => {
                                // 创建一个Canvas元素
                                var canvas = document.createElement("canvas");
                                var context = canvas.getContext("2d");

                                // 设置Canvas的宽度和高度与图片相同
                                canvas.width = image.width;
                                canvas.height = image.height;

                                var borderRadius = 100; // 圆角半径
                                var width = image.width;
                                var height = image.height;
                                // 绘制圆角矩形路径
                                context.beginPath();
                                context.moveTo(borderRadius, 0);
                                context.lineTo(width - borderRadius, 0);
                                context.arcTo(width, 0, width, borderRadius, borderRadius);
                                context.lineTo(width, height - borderRadius);
                                context.arcTo(width, height, width - borderRadius, height, borderRadius);
                                context.lineTo(borderRadius, height);
                                context.arcTo(0, height, 0, height - borderRadius, borderRadius);
                                context.lineTo(0, borderRadius);
                                context.arcTo(0, 0, borderRadius, 0, borderRadius);
                                context.closePath();

                                // 剪切圆角路径
                                context.clip();

                                // 在Canvas上绘制原始图片
                                context.drawImage(image, 0, 0);

                                // 获取图像的像素数据
                                var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                                var data = imageData.data;

                                // 处理像素数据
                                for (var i = 0; i < data.length; i += 4) {
                                    var red = data[i];
                                    var green = data[i + 1];
                                    var blue = data[i + 2];
                                    var alpha = data[i + 3];

                                    // 将灰色部分去掉，并将浅白色部分设置为透明
                                    var average = (red + green + blue) / 3;
                                    if (average < 128) {
                                        data[i] = data[i + 1] = data[i + 2] = 0; // 黑色
                                    } else {
                                        data[i + 3] = 0; // 透明
                                    }
                                }
                                // 将处理后的像素数据放回Canvas
                                context.putImageData(imageData, 0, 0);
                                // 将Canvas转换为PNG文件
                                var pngDataUrl = canvas.toDataURL("image/png");
                                console.log(this)
                                this.handleProcessedImage(pngDataUrl)
                            };
                        });
                    }
                } else {
                    if (this.timeoutCallback) {
                        this.timeoutCallback()
                    }
                }
                this.close()
            } else if (stateCode == Fp.RT_FP_CANCEL) {
                Fp.log("getImage task cancelled")
            } else {
                if (this.lastStateCode != stateCode) {
                    this.lastStateCode = stateCode
                    switch (stateCode) {
                        case -1:
                            break;
                        case Fp.RT_BAD_QUALITY:
                            Fp.log("##Bad fingerprint quality, please retry")
                            break;
                        default:
                            Fp.log("stateCode:", stateCode)
                    }
                    if (stateCode == -1) {
                        if (this.offlineCallback) {
                            this.offlineCallback()
                        }
                        return
                    }
                }
                Fp.sleep(200)
                this.getImage()
            }
        })
    }
    init() {
        Fp.connect(() => {
            Fp.log("fingerprint service connect succ")
            Fp.setDeviceType(Fp.SCSI_DEVICE, () => {
                // 连接指纹仪
                // Fp.deviceCount(function (returnObj){
                //     Fp.log("device count:" + returnObj.count)
                //
                //     if( returnObj.count > 0 ){
                //     }else{
                //         Fp.log("Please insert fingerprint")
                //     }
                // })
                Fp.log("start open device")
                Fp.openDevice(-1, (returnObj) => {
                    this.handle = returnObj.handle
                    console.log('returnObj:', returnObj, 'returnObj.handle:', returnObj.handle)
                    if (this.handle > 0) {
                        Fp.log("openDevice succ, handle:" + this.handle);
                        if (this.initokCallback) {
                            this.initokCallback()
                        }
                        this.getImage();
                    } else {
                        Fp.log("openDevice failed")
                        if (this.offlineCallback) {
                            this.offlineCallback()
                        }
                    }
                })
            })
        })
    }
    close() {
        Fp.closeDevice(this.handle, (returnObj) => {
            if (returnObj.retCode == Fp.RT_SUCCESS) {
                Fp.log("device closed")
            }
        })
    }
}